import type { ReactNode } from 'react';

export const symbol_airline_seat_legroom_extra: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M490-280H140q-24.75 0-42.37-17.63Q80-315.25 80-340v-470q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v470h350q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5Zm116-130H340q-45 0-77.5-32.5T230-520v-290q0-12.75 8.63-21.38Q247.25-840 260-840h160q12.75 0 21.38 8.62Q450-822.75 450-810v220h130q20.36 0 37.18 11T643-550l146 300 58-26q19-8 38.5-3t30.5 25q11 19 3.78 38.93Q912.55-195.14 893-186l-119 54q-11 5-23 1t-17-15L606-410Z"
		/>
	</svg>
);
